'use strict';

var _ = require('lodash');
function InventoryManagementGridController($scope, $timeout, $q, constants, dataService, flightDataAdjustmentService, flightAdjustmentValidationService) {
  $scope.gridId = constants.GRIDS.INVENTORY_MANAGEMENT;
  $scope.isNotApplicableMessage = true;
  $scope.onSelectFlights = function (selectedFlights) {
    $scope.isNotApplicableMessage = !isApplicable(selectedFlights);
    if ($scope.isNotApplicableMessage) {
      $scope.$broadcast('grid:clearAndLoadData:' + $scope.gridId);
      return;
    }
    $timeout(function () {
      $scope.$broadcast('grid:clearAndLoadData:' + $scope.gridId);
    }, 150);
  };
  $scope.onPanel = function (ev, isExpanded) {
    if (isExpanded && isApplicable($scope.selectedFlights)) {
      $timeout(function () {
        $scope.$broadcast('grid:clearAndLoadData:' + $scope.gridId);
      }, 150);
    }
  };
  $scope.reloadData = function () {
    if (!isApplicable($scope.selectedFlights)) {
      return $q.when([]);
    }
    return dataService.getData($scope.selectedFlights);
  };
  $scope.customSaveValidation = function (rows) {
    return flightAdjustmentValidationService.validateRows(rows);
  };
  $scope.customSaveDataAdjuster = function (rows) {
    return flightDataAdjustmentService.adjustData(rows);
  };
  function isApplicable(selectedFlights) {
    return _(selectedFlights).groupBy('flightId').size() === 1;
  }
}
InventoryManagementGridController.$inject = ['$scope', '$timeout', '$q', 'FlightManagementConstants', 'InventoryManagementDataService', 'FlightDataAdjustmentService', 'FlightAdjustmentValidationService'];
module.exports = InventoryManagementGridController;